<!-- 验证码输入框 可以自定义位数-->
<template>
<div name="codeInput" class="vcode-input-box">
    <div class="vcode-input-body" v-for="(index) in this.len" :key="index">
        <input type="text" :index="index" ref="inputCode" class="vcode-input" :class="codes[index-1]?'vcode-input-on':''" 
        @input="onInput" @keyup.delete="deleteCode" @keyup.left="leftFocus" @keyup.right="rightFocus">
    </div>
</div>
</template>
<script>
export default {
    props: [
        'len',
        'singleRule',
    ],
    data() {
        return {
          codes: [],
        }
    },
    watch: {
        len(val){
            this.codes = Array.apply(null,new Array(val));
        }
    },
    methods: {
        init(){
            this.codes = Array.apply(null,new Array(this.len));
            this.$refs.inputCode.forEach(item => {
                item.value = "";
            });
        },
        onInput(e){
            let val = e.target.value;
            let index = Number(e.target.getAttribute("index"));
            if(this.codes[index-1]&&val){
                //如果已有内容，无法输入
                this.$refs.inputCode[index-1].value = this.codes[index-1];
                return;
            }
            //输入触发
            if(val.length>0){
                if(!this.checkSingleRule(val)){
                    //校验失败不输入
                    this.$refs.inputCode[index-1].value = "";
                    return;
                }
                let lastIndex = index>(this.len-1)?this.len-1:index;
                if(val.length>1){
                    //如果是粘贴的大于1，则拆分为数组并自动录入，多余位数的舍弃
                    let vals = val.split("");
                    let max = this.len>(vals.length+index)?(vals.length+index):this.len;
                    for(let i = index;i<=max;i++){
                        this.$refs.inputCode[i-1].value = vals[i-index];
                        this.codes[i-1]  = vals[i-index];
                    }
                    //最后一位位置
                    lastIndex = max-1;
                }else{
                    this.codes[index-1] = val;
                }
                this.$forceUpdate();
                if(this.len-1<index){
                    //最末尾无需移动
                    return;
                }
                //锁定下一个位置
                this.$refs.inputCode[lastIndex].focus();
                return;
            }
        },
        deleteCode(e){
            let val = e.target.value;
            let index = Number(e.target.getAttribute("index"));
            //如果是退格
            if(val.length<1){
                if(this.codes[index-1]){
                    //存储的值不为空则置为空
                    this.codes[index-1] = "";
                }else{
                    //存储的值也为空，则焦点到上一个输入框
                    this.leftFocus(e);
                }
                this.$forceUpdate();
            }
        },
        leftFocus(e){
            let index = Number(e.target.getAttribute("index"));
            if(index==1){
                //第一个无需移动
                return;
            }
            let beforeIndex = index-2;
            this.$refs.inputCode[beforeIndex].focus();
        },
        rightFocus(e){
            let index = Number(e.target.getAttribute("index"));
            if(this.len-1<index){
                //最末尾无需移动
                return;
            }
            let lastIndex = index;
            this.$refs.inputCode[lastIndex].focus();
            //使光标始终在末尾
            this.$refs.inputCode[lastIndex].value = "";
            if(this.codes[lastIndex]){
                this.$refs.inputCode[lastIndex].value = this.codes[lastIndex];
            }
        },
        checkSingleRule(val){
            if(!val||!this.singleRule){
                //空不进行验证
                return true;
            }
            //校验规则
            if(this.singleRule){
                if(this.singleRule=="num"){
                    this.singleRule = /^[0-9]*$/;
                }
                return this.singleRule.test(val);
            }
        },
        getCode(){
            return this.codes.join("");
        }
    }
}
</script>
<style scoped>

.vcode-input-box {
    width: auto;
    height: auto;
    display:flex;
    justify-content: center;
    width: 420Px;
    margin: auto;
}

.vcode-input-body {
    margin: auto;
}

.vcode-input {
    width: 40Px;
    height: 40Px;
    background: #FFFFFF;
    border: 1Px solid #E0EAF9;
    opacity: 1;
    border-radius: 6Px;
    font-size: 18Px;
    font-family: Arial;
    font-weight: 400;
    line-height: 40Px;
    color: #000000;
    margin: 0;
    padding: 14Px
}

.vcode-input-on {
    border: 1Px solid #8A96E3;
}
</style>


// WEBPACK FOOTER //
// src/components/common/input/code_input.vue